module.exports = __webpack_public_path__ + "static/media/bmx-woods.8520959b.mov";